module.exports = __webpack_public_path__ + "img/feature_buy_zh.c1f7cc86.png";